module.exports = __webpack_public_path__ + "static/img/consult-bcg.d2150a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/consult-bcg.png
// module id = KkEJ
// module chunks = 0